import * as React from "react"

import { Link } from "./library/link"

import { Set } from "immutable"

import { Button } from "./library/button"
import { trackLogin } from "./library/tracking"

import { ApiResult } from "../../../Shared/api/apiTypes"
import { NavigationItem } from "../../../Shared/api/drupal/drupalTypes"
import { isActivePath } from "../../../Shared/utils/browser"
import { errorText, getNavigation } from "../../custom_api/api"
import { library } from "../../libraries"
import { GoogleTranslateMenuItem } from "../../../Shared/components/GoogleTranslate/GoogleTranslateMenuItem"

interface HeaderProps {
  searchModalOpen: boolean,
  toggleSearchModal: () => void
}

interface HeaderState {
  readonly items: ApiResult<Set<NavigationItem>>
  readonly secondaryItems: ApiResult<Set<NavigationItem>>
  readonly menuOpen: boolean
}

const navigationStateZero: HeaderState = {
  items: "loading",
  secondaryItems: 'loading',
  menuOpen: false
}

type MenuProps = {
  items: Set<NavigationItem>
  handle?: () => void
  menuOpen?: boolean
  secondaryItems: ApiResult<Set<NavigationItem>>
  toggleMenu: () => void,
  toggleSearchModal?: () => void
  searchModalOpen?: boolean
}

class Menu extends React.Component<MenuProps, {}> {
  constructor(props: MenuProps & { secondaryItems: ApiResult<Set<NavigationItem>> }) {
    super(props)
    this.state = {}
  }

  render() {
    const p = this.props

    // TODO: Currently, the Desktop & Mobile version of the header are loaded at the same time.
    // We should either refactor this so the menu cannot be focused while on either other version

    return (
      <nav className="nav" aria-label="Primair">
        <DesktopMenu 
          items={p.items} 
          secondaryItems={p.secondaryItems} 
          toggleMenu={this.props.toggleMenu} 
          toggleSearchModal={p.toggleSearchModal} 
          searchModalOpen={p.searchModalOpen} 
        />
        <Button
          className="nav__toggler"
          handle={this.props.toggleMenu}
          buttonProps={{
            'aria-controls': 'a11y-nav-collapse',
            'aria-expanded': this.props.menuOpen,
          }}
        >
          Menu <span className="sr-text">{this.props.menuOpen ? 'sluiten' : 'openen'}</span>
          <div className="nav__hamburger">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </div>
        </Button>

        <MobileMenu 
          items={p.items} 
          handle={this.props.toggleMenu} 
          menuOpen={this.props.menuOpen} 
          secondaryItems={p.secondaryItems} 
          toggleMenu={this.props.toggleMenu} 
          toggleSearchModal={p.toggleSearchModal} 
          searchModalOpen={p.searchModalOpen} 
        />
      </nav>
    )
  }
}

interface SecondaryMobileMenuprops {
  items: ApiResult<Set<NavigationItem>>
  handle: () => void
}

const SecondaryMobileMenu: React.SFC<SecondaryMobileMenuprops> = props => {
  if (props.items == 'loading' || props.items == 'error') return null

  return <ul className="utilities__menu utilities__menu--mobile">
    {props.items.toArray().map((m, i) => (
      m.external ? (
        <li className="utilities__menu-item" key={i}>
          <a
            className="utilities__menu-link"
            href={m.absolute}
            target="_blank"
            rel="noopener noreferrer"
          >{m.title}</a>
        </li>
      ) : (
        <li className="utilities__menu-item" key={i}>
          <Link
            handle={() => props.handle()}
            className={`utilities__menu-link ${isActivePath(m.relative) ? 'utilities__menu-link--active' : ''}`}
            url={m.relative}
          >{m.title}</Link>
        </li>
      )
    ))}
    <GoogleTranslateMenuItem mobile={true} />
  </ul>
}


const SecondaryDesktopMenu: React.SFC<{ items: ApiResult<Set<NavigationItem>> }> = props => {
  if (props.items == 'loading' || props.items == 'error') return null

  return <div className="header__utility utilities--desktop">
    <nav className="utilities__nav" aria-label="Secondary navigation">
      <ul className="utilities__menu">
        {props.items.toArray().map((m, i) => (
          m.external ? (
            <li className="utilities__menu-item" key={i}>
              <a
                className="utilities__menu-link"
                href={m.absolute}
                target="_blank"
                rel="noopener noreferrer"
              >{m.title}</a>
            </li>
          ) : (
            <li className="utilities__menu-item" key={i}>
              <Link
                className={`utilities__menu-link ${isActivePath(m.relative) ? 'utilities__menu-link--active' : ''}`}
                url={m.relative}
              >{m.title}</Link>
            </li>
          )
        ))}

        <GoogleTranslateMenuItem />

        <li className="utilities__menu-item">
          <Link url={library().loginUrl} className="utilities__menu-button button button--secondary-beige nav__button" external={true} handle={() => trackLogin()}>
          <span className="button__label">Log in</span>
          </Link>
        </li>
      </ul>
    </nav>
  </div>
}

const MobileMenu: React.SFC<MenuProps> = props => {
  const { items, menuOpen, searchModalOpen, secondaryItems, handle, toggleSearchModal  } = props
  const lib = library()
  return (
    <div className="menu-wrap" id="a11y-nav-collapse" hidden={!menuOpen} aria-hidden={!menuOpen}>
      <div className="menu-wrap__inner">
        <ul className="menu menu--mobile">
          {items.map(x => (
            <li key={`li-${x.key}`} className="menu__item">
              {lib.menuLink(x, handle)}
            </li>
          ))}
        
          <li className="menu__item">
            <button
              className={"menu__link link--iconed"}
              onClick={() => toggleSearchModal()}
              aria-controls="a11y-search-modal"
              aria-expanded={searchModalOpen}
            >
              Zoeken
              <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--menu-search" /></svg>
            </button>
          </li>
        </ul>

        <SecondaryMobileMenu handle={handle} items={secondaryItems} />

        <Link
          url={lib.loginUrl}
          className="button button--primary nav__button"
          external={true}
          handle={() => trackLogin()}
        >
          <span className="button__label">Log in</span>
        </Link>
      </div>
    </div>
  )
}

const DesktopMenu: React.SFC<MenuProps> = props => {
  const lib = library()
  return (
    <ul className="menu menu--desktop"  hidden={!props.menuOpen} aria-hidden={!props.menuOpen}>
      {props.items.map(x => (
        <li key={`li-${x.key}`} className="menu__item">
          {lib.menuLink(x, () => {})}
        </li>
      ))}
      <li className="menu__item">
        <button
          className={"menu__link link--iconed"}
          onClick={() => props.toggleSearchModal()}
          aria-controls="a11y-search-modal"
          aria-expanded={props.searchModalOpen}
        >
          Zoeken
          <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--menu-search" /></svg>
        </button>
      </li>
    </ul>
  )
}



type LogoProps = {
  closeMenu: () => void
}

const Logo = (props: LogoProps) => {
  return (
    <Link url="/" className="logo" title="Ga naar de homepagina" handle={props.closeMenu}>
      <span className="sr-text">Ga naar de homepagina</span>
      { library().logo() }
    </Link>
  ) 
}

export class Header extends React.Component<HeaderProps, HeaderState> {
  constructor(props: HeaderProps) {
    super(props)

    this.state = navigationStateZero
    this.toggleMenu = this.toggleMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
  }

  closeMenu() {
    this.setState(
      s => ({ ...s, menuOpen: false }),
      () => (document.body.classList.remove("menu--toggled"))
    )
  }

  toggleMenu() {
    this.setState(
      s => ({ ...s, menuOpen: !s.menuOpen }),
      () => (this.state.menuOpen ? document.body.classList.add("menu--toggled") : document.body.classList.remove("menu--toggled"))
    )
  }

  componentDidMount() {
    const p = this.props

    getNavigation("main").then(res => {
      if (res != "error" && res != "loading") {
        const items = Set(res)

        this.setState(s => ({ ...s, items: items }))
      }
    })

    getNavigation("main-secondary").then(res => {
      if (res != "error" && res != "loading") {
        const items = Set(res)

        this.setState(s => ({ ...s, secondaryItems: items }))
      }
    })
  }

  render() {
    const s = this.state

    return (
      <>
        <a href="#a11y-main" className="sr-text">Ga direct naar de content</a>
        <a href="#a11y-footer" className="sr-text">Ga direct naar de footer</a>
        <header className="header">
          <div className="header__inner container--full gutter--m align--center">
            <div className="header__container">
              <Logo closeMenu={() => this.closeMenu()} />
              {s.items == "loading" ? null : s.items == "error" ? ( // loadingText
                errorText
              ) : (
                <Menu items={s.items} secondaryItems={s.secondaryItems} menuOpen={s.menuOpen} toggleMenu={this.toggleMenu} toggleSearchModal={() => {this.closeMenu(); this.props.toggleSearchModal()}} searchModalOpen={this.props.searchModalOpen} />
              )}
            </div>
            <SecondaryDesktopMenu items={s.secondaryItems} />
          </div>
        </header>
      </>
    )
  }
}

{/* TH: Added to styleguide! */ }

